import {
    ChangeAdaptivePayload,
    CommandResponse,
    RevisionedCommandResponse,
    SchemaConfiguration,
    StudyEntityType,
    toSchemaConfiguration,
    UpdateBlindingSchemaPayload,
    UpdatePopulationPayload,
} from '@faro/study-designer-model';
import axios from 'axios';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { StudyPathParameter } from '../parameter';

const factory = createStudyEntityHookFactory<SchemaConfiguration>(StudyEntityType.SchemaConfiguration);

export const useSchemaConfigurations = factory.list(
    (
        { studyId, ...query }: StudyPathParameter & { revision?: number },
        signal?: AbortSignal
    ): Promise<SchemaConfiguration[]> => {
        return axios
            .get(`/api/study-designer/studies/${studyId}/schema-configuration`, {
                signal,
                params: query,
            })
            .then(response => response.data?.map(toSchemaConfiguration) ?? []);
    }
);

export const useSchemaConfiguration = factory.get(
    (
        { studyId, id, ...query }: StudyPathParameter & { id: string; revision?: number },
        signal?: AbortSignal
    ): Promise<SchemaConfiguration> => {
        return axios
            .get(`/api/study-designer/studies/${studyId}/schema-configuration/${id}`, {
                signal,
                params: query,
            })
            .then(response => toSchemaConfiguration(response.data));
    }
);

export const useSchemaConfigurationChangeAdaptive = factory.mutate(
    (entity: {
        id: string;
        studyId: string;
        payload: ChangeAdaptivePayload;
    }): Promise<RevisionedCommandResponse<CommandResponse>> => {
        const { id, studyId, payload } = entity;
        return axios
            .post(`/api/study-designer/studies/${studyId}/schema-configuration/${id}/actions/change-adaptive`, payload)
            .then(response => response.data);
    }
);

export const useSchemaConfigurationUpdateBlindingSchema = factory.mutate(
    (entity: {
        schemaConfigurationId: string;
        studyId: string;
        payload: UpdateBlindingSchemaPayload;
    }): Promise<RevisionedCommandResponse<CommandResponse>> => {
        const { schemaConfigurationId, studyId, payload } = entity;
        console.log('useSchemaConfigurationUpdateBlindingSchema', entity);
        return axios
            .post(
                `/api/study-designer/studies/${studyId}/schema-configuration/${schemaConfigurationId}/actions/update-blinding-schema`,
                payload
            )
            .then(response => response.data);
    }
);

export const useSchemaConfigurationUpdatePopulation = factory.mutate(
    (entity: {
        id: string;
        studyId: string;
        payload: UpdatePopulationPayload;
    }): Promise<RevisionedCommandResponse<CommandResponse>> => {
        const { id, studyId, payload } = entity;
        return axios
            .post(
                `/api/study-designer/studies/${studyId}/schema-configuration/${id}/actions/update-population`,
                payload
            )
            .then(response => response.data);
    }
);
